import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {ImageWrapperComponent} from "@cybfed/shared/components/image-wrapper/image-wrapper.component";
import {RouterModule} from "@angular/router";
import {HeaderStatsBannerModel} from "@white-label/components/page-builder/models/header-stats-banner.model";
import {VideoPlayerComponent} from "@white-label/components/white-label/video-player/video-player.component";
import {MainStoreService} from "@cybfed/core/store/main.store.service";
import {ButtonComponent} from "@white-label/components/white-label/button/button.component";
import {IconX} from "../../../../../../../../../shared/assets/icons/ts/icon-x";
import {IconYoutube} from "../../../../../../../../../shared/assets/icons/ts/icon-youtube";
import {IconFb} from "../../../../../../../../../shared/assets/icons/ts/icon-fb";
import {IconInstagram} from "../../../../../../../../../shared/assets/icons/ts/icon-instagram";
import {IconTelegram} from "../../../../../../../../../shared/assets/icons/ts/icon-telegram";
import {IconTiktok} from "../../../../../../../../../shared/assets/icons/ts/icon-tiktok";
import {IconDiscord} from "../../../../../../../../../shared/assets/icons/ts/icon-discord";
import {IconTwitch} from "../../../../../../../../../shared/assets/icons/ts/icon-twitch";

@Component({
    selector: 'app-header-stats-banner-component',
    standalone: true,
    imports: [
        TranslateModule,
        ImageWrapperComponent,
        RouterModule,
        VideoPlayerComponent,
        ButtonComponent,
        IconX,
        IconYoutube,
        IconFb,
        IconInstagram,
        IconTelegram,
        IconTiktok,
        IconDiscord,
        IconTwitch,
    ],
    providers: [],
    templateUrl: './header-stats-banner.component.html'
})
export class HeaderStatsBannerComponent implements  AfterViewInit{
    @Input() componentModel: HeaderStatsBannerModel = new HeaderStatsBannerModel();
    @ViewChild('videoPlayer') video?: ElementRef;
    isMuted: boolean = true;
    langPath = ''
    styling: any
    constructor(public mainStore: MainStoreService) {
        this.styling = mainStore?.whiteLabel?.styling
    }

    toggleMute() {
        this.isMuted = !this.isMuted;
        if(this.video){
            const video = this.video.nativeElement;
            video.muted = this.isMuted; // Ensure the video is muted
        }
    }

    ngAfterViewInit() {
        if(this.componentModel.videoUrl?.value && this.video){
            const video = this.video.nativeElement;
            video.muted = this.isMuted;

            video.addEventListener('loadeddata', () => {
                video.play().catch(error => {
                    console.error('Error attempting to play video:', error);
                });
            });
        }
        this.langPath = this.componentModel.location.options[0]?.value
    }

    onImageError(event: any){
        (event.target as HTMLImageElement).src = '/assets/image/default-image.png';
    }
}
